import React from 'react';
import SinglePost from '../mainFeed/postTypes/singlePostContainer';

const OwnPosts = ({ posts }) => {
  return (
    <div style={{ width: '50%', margin: 'auto' }}>
      {
        posts.map(post => {
          return (<SinglePost key={post.postId} { ...post } />);
        })
      }
    </div>
  );
};

export default OwnPosts;



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/ownerMetaDataPages/posts.jsx